import React from "react";

const FloatingButton = () => {
  return (
    <a
      href="tel:+989150064036"
      className="floating-button"
      aria-label="Call me"
    >
      <i className="fa fa-phone" aria-hidden="true"></i>
    </a>
  );
};

export default FloatingButton;
